module.exports = __webpack_public_path__ + "static/media/linkWallets.c6f2b389.PNG";